// @ts-ignore
import React, { useRef, useState } from "react";

import Routes from "./routes/routes";
// @ts-ignore
import { useDispatch, useSelector } from "react-redux";
import MxAlerta from "./Componentes/MxAlerta";
import { MxAlertaActions } from "./store/ducks/components/mxalerta/mxalerta";
// import { useRegisterSW } from "virtual:pwa-register/react";
// @ts-ignore
import { persistor, store } from "./store";
import { TypesUpdateApp } from "./store/ducks/application/updateapp/updateapp";
import axios from "axios";
import { useTypedSelector } from "./hooks/useTypedSelector";
import { useQuery } from "react-query";
import Box from "@material-ui/core/Box";
import { MxUtils } from "./utils/mxutils";
import { useHistory } from "react-router-dom";

function App() {
    const dispatch = useDispatch();
    const updateServiceWorker = useUpdateServiceWorker();

    function handleSwError(err) {
        console.log(err);
        dispatch(
            MxAlertaActions.Executar("Erro ao iniciar service worker", "error")
        );
    }

    function handleSwUpdate(registration) {
        dispatch({ type: TypesUpdateApp.SW_UPDATE, payload: registration });
        dispatch(
            MxAlertaActions.ExecutarComButtonAtualizarApp(
                "Existe uma atualização no aplicativo! Deseja recarregar a página?",
                "warning"
            )
        );
    }
    function handleSwSuccess() {
        dispatch({ type: TypesUpdateApp.SW_INIT });
        dispatch(
            MxAlertaActions.Executar(
                "Seu aplicativo está atualizado!",
                "success"
            )
        );
    }
    function handleSwOfflineReady() {
        //console.log("App está pronto para uso offline!");
    }
    const isServiceWorkerSupported = useServiceWorker({
        onSuccess: handleSwSuccess,
        onUpdate: handleSwUpdate,
        onError: handleSwError,
        onOfflineReady: handleSwOfflineReady
    });
    useQueryUpdateServiceWorker(isServiceWorkerSupported);
    useQueryCheckPasswordExpirationDate();
    return (
        <Box
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column"
            }}
        >
            {/* Componente de alerta que servirá para todas as telas da aplicação ! */}
            <MxAlerta
                onClick={() => {
                    updateServiceWorker();
                }}
            />

            <Routes />
        </Box>
    );
}

export default App;

function useUpdateServiceWorker() {
    const dispatch = useDispatch();
    // const isServiceWorkerInitialized = useTypedSelector(
    //     state => state.updateappreducer.serviceWorkerInitialized
    // );
    // const isServiceWorkerUpdated = useTypedSelector(
    //     state => state.updateappreducer.serviceWorkerUpdated
    // );
    const serviceWorkerRegistration = useTypedSelector(
        state => state.updateappreducer?.serviceWorkerRegistration
    );

    return () => {
        if (!serviceWorkerRegistration) return;
        const registrationWaiting = serviceWorkerRegistration?.waiting;

        if (registrationWaiting) {
            registrationWaiting.postMessage({ type: "SKIP_WAITING" });

            registrationWaiting.addEventListener("statechange", e => {
                if (e.target.state === "activated") {
                    navigator.serviceWorker.ready.then(registration => {
                        registration.unregister().then(() => {
                            dispatch({ type: "ROOT/RESET" });
                            persistor.flush().then(() => {
                                window.location.reload();
                            });
                        });
                    });
                }
            });
        }
    };
}

function useServiceWorker({
    onSuccess = _reg => { },
    onUpdate = _reg => { },
    onError = _err => { },
    onOfflineReady = () => { }
}) {
    const isLocalhost = Boolean(
        window.location.hostname === "localhost" ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === "[::1]" ||
        // 127.0.0.0/8 are considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    //Necessário checar se está em produção pois SW não funciona com o webpack --watch
    // @ts-ignore
    if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
        // @ts-ignore
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
        if (publicUrl.origin !== window.location.origin) return false;
        window.addEventListener("load", () => {
            // @ts-ignore
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            if (isLocalhost) {
                checkServiceWorker(swUrl);
            } else {
                registerServiceWorker(swUrl);
            }
        });
        return true;
    } else {
        console.log("Service Worker não suportado!");
        return false;
    }

    /**
     * @param {string} swUrl
     */
    function registerServiceWorker(swUrl) {
        navigator.serviceWorker
            .register(swUrl)
            .then(registration => {
                //Necessário para manter referência do serviceWorker quando passado para o onstatechange
                registration.onupdatefound = () => {
                    const installingWorker = registration.installing;
                    if (installingWorker === null) return;

                    installingWorker.onstatechange = () => {
                        if (installingWorker.state === "installed") {
                            if (navigator.serviceWorker.controller)
                                onUpdate(registration);
                            else onSuccess(registration);
                        }
                    };
                };
            })
            .catch(err => {
                onError(err);
            });
    }

    /**
     * @param {string} swUrl
     */
    function checkServiceWorker(swUrl) {
        //Se é localhost, verifica se já existe um sw
        axios
            .get(swUrl, { headers: { "Service-Worker": "script" } })
            .then(response => {
                const contentType = response.headers["content-type"];
                if (
                    !(response.status === 404) &&
                    contentType &&
                    contentType.indexOf("javascript") !== -1
                ) {
                    registerServiceWorker(swUrl);
                    onOfflineReady();
                    return;
                }
                navigator.serviceWorker.ready.then(registration => {
                    registration.unregister().then(() => {
                        window.location.reload();
                    });
                    return;
                });
            })
            // @ts-ignore
            .catch(err => {
                console.log(err, err.response);
                console.log(
                    "Sem conexão com a internet. App está rodando em modo offline."
                );
            });
    }
}

/**
 * Função que verifica se existe uma nova versão do Service Worker a cada 15 min ou quando o usuário entra na aplicação
 * @returns {import("react-query").UseQueryResult<boolean, unknown>}
 */
function useQueryUpdateServiceWorker(enabled = true) {
    return useQuery(
        ["Global", "UpdateServiceWorker"],
        () =>
            new Promise((resolve, reject) => {
                if (
                    "serviceWorker" in navigator &&
                    // @ts-ignore
                    process.env.NODE_ENV === "production"
                ) {
                    navigator.serviceWorker.ready
                        .then(registration => {
                            registration.update().then(() => resolve(true));
                        })
                        .catch(e => reject(e));
                } else resolve(false);
            }),
        {
            staleTime: 15 * 60 * 1000, //15 minutos
            retry: 1,
            refetchOnWindowFocus: "always",
            enabled
        }
    );
}

/**
 * Função que verifica se a senha do usuário está próxima de expirar automaticamente a cada 12h
 * @returns
 */
function useQueryCheckPasswordExpirationDate() {
    const history = useHistory();
    return useQuery(
        ["Global", "CheckPasswordExpirationDate"],
        () => {
            if (
                !MxUtils.getToken() || // Não está logado
                window.location.pathname === "/" || // Na Tela de login
                window.location.pathname === "/alterarsenha" // Alterando a senha
            ) {
                return;
            } else if (window.location.pathname === "/") {

                const hoursUntilExpiration = MxUtils.getHorasParaExpirarSenhaUsuario();

                if (hoursUntilExpiration <= 240) {
                    MxUtils.alertaConfirm(
                        "Expiração de Senha",
                        `Sua senha expira em ${(
                            hoursUntilExpiration / 24
                        ).toLocaleString("pt-BR", {
                            maximumFractionDigits: 1
                        })} dias. Deseja alterar sua senha agora?`,
                        () => {
                            history.push("/alterarsenha");
                        },
                        () => {
                            MxUtils.closeAlertaConfirm();
                        }
                    );
                } else if (hoursUntilExpiration <= 24) {
                    history.push("/alterarsenha");
                }
            }
        },
        {
            staleTime: 12 * 60 * 60 * 1000 //12 horas
        }
    );
}
